import React from 'react';
import { Button } from 'react-bootstrap';
import { TopNotification } from '../../../ui/TopNotification/TopNotification';
import styles from './SidePanelAnnouncement.module.scss';

export type SidePanelAnnouncementProps = {
  /** Dismiss handler: persists the creator's choice and hides the notice. */
  onClose: () => void;
};

/**
 * First-run notice for the default-on Side-by-Side Editor rollout.
 *
 * It only informs: there is no toggle here. The single switch stays in the
 * Experimental section, and the notice points to its exact location so a
 * creator can find it. Dismissing the notice (the button or the cross) is what
 * records awareness, so it does not reappear.
 */
export function SidePanelAnnouncement({ onClose }: SidePanelAnnouncementProps) {
  return (
    <TopNotification onClose={onClose}>
      <div className={styles.title}>The editor now opens side-by-side</div>
      <p className={styles.text}>
        Editing a node now shows the form next to the live preview, so you see the
        player experience while you edit. This is on by default.
      </p>
      <p className={styles.text}>Prefer the old editor? You can switch it off here:</p>
      <ul className={styles.path}>
        <li>Open the <strong>left menu</strong></li>
        <li>Scroll to <strong>Experimental</strong> at the bottom of the panel</li>
        <li>Turn off <strong>Side-by-Side Editor</strong></li>
      </ul>
      <div className={styles.actions}>
        <Button size="sm" variant="primary" onClick={onClose}>
          Got it
        </Button>
      </div>
    </TopNotification>
  );
}
